import styled from 'styled-components';
import { WhiteBackgroundRowItem } from './Common.styled';

// Time Display Container (extends WhiteBackgroundRowItem with time-specific styling)
export const TimeDisplayContainer = styled(WhiteBackgroundRowItem)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  width: 100%;
  min-width: 280px;
  max-width: 320px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) => props.theme.colors.glassBackground};
    border-radius: ${(props) => props.theme.effects.borderRadiusLarge};
    opacity: 0.3;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: ${(props) => props.theme.colors.glassBackground};
    border-radius: 50%;
    opacity: 0;
    transition: ${(props) => props.theme.effects.transitionMedium}; /* Simplified for TV performance */
    z-index: -1;
  }

  &:hover::after {
    opacity: 0.2;
    transform: scale(1.05); /* Reduced from 1.2 for TV performance */
  }
`;

// City Name — solid color (transparent text-fill + glass bg hides labels on Tizen)
export const CityName = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.textPrimary || '#ffffff'};
  text-align: center;
  margin-bottom: 10px;
  transition: ${(props) => props.theme.effects?.transitionMedium || 'all 0.25s ease-out'};
`;

// Clock Container - Optimized for TV
export const ClockContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  padding: 15px;
  background: ${(props) => props.theme.colors.glassBackground};
  border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  transition: ${(props) => props.theme.effects.transitionMedium};
  
  &:hover {
    transform: translateY(-2px); /* Reduced from -5px for better performance */
   
  }
  
  .react-clock {
    background: ${(props) => props.theme.colors.glassBackground};
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    padding: 10px;
    backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
    transition: ${(props) => props.theme.effects.transitionMedium};
    
    &:hover {
      transform: scale(1.02); /* Reduced from 1.05 for better performance */
    }
  }

  .react-clock__face {
    background: ${(props) => props.theme.colors.glassBackground}; /* Simplified for TV */
    border: 1px solid ${(props) => props.theme.colors.glassOverlay};
    border-radius: 50%;
  }

  .react-clock__mark,
  .react-clock__mark__body,
  .react-clock__hand,
  .react-clock__hand__body {
    background: ${(props) => props.theme.colors.textPrimary};
  }

  .react-clock__second-hand__body {
    background: #e74c3c;
  }

  .react-clock__number {
    color: ${(props) => props.theme.colors.textPrimary};
    /* text-shadow removed for TV performance */
    font-weight: 600;
    font-size: 14px;
  }
`; 